import { ReportsType } from '@features/reports/enums/reportsType'
import { GenericTableRow } from '@features/reports/utils/buildTableData'
import { getVisibleColumns } from '@features/reports/views/NL/profitAndLossReport/constants/columnConfiguration'
import { ProfitAndLossTableBalance } from '@features/reports/views/NL/profitAndLossReport/types/tableTypes'

import { useReportsPdfDocument } from '../../../../contexts/reportsPdfDocumentContext'
import { ReportsPdfTableBalanceCell } from '../ReportsPdfTableBalanceCell'

interface ProfitAndLossBalanceCellProps {
  row: GenericTableRow<ProfitAndLossTableBalance>
}

export const ProfitAndLossBalanceCell = ({ row }: ProfitAndLossBalanceCellProps) => {
  const { appliedFilters, periods, reportType } = useReportsPdfDocument()

  if (reportType !== ReportsType.ProfitAndLoss) {
    return <></>
  }

  const visibleColumns = getVisibleColumns(appliedFilters.showChange, appliedFilters.showGroupPercentage)

  return periods?.map((period) => {
    const balance = row.balances.find((balance) => balance.period === period.key)?.balance

    if (!balance) {
      return <></>
    }

    return (
      <>
        {visibleColumns.map((column) => (
          <ReportsPdfTableBalanceCell
            key={column.key}
            balance={balance[column.key]}
            columnKey={column.key}
            rowType={row.type}
          />
        ))}
      </>
    )
  })
}
